module.exports = __webpack_public_path__ + "img/20_130.f08c84a4.png";